// ============================================================================
// File: Sparkline.tsx — Spec 197
// A tiny inline trend line for dashboard sub-tiles (no axes/grid). Renders
// nothing until there are ≥2 points so empty tiles stay clean.
// ============================================================================
import React from 'react';
import { LineChart, Line, XAxis, ResponsiveContainer, Tooltip } from 'recharts';
import { chartTooltipStyle } from '@/components/ui';

export interface SparklineProps {
  data: Array<{ date: string; value: number }>;
  color?: string;
  /** Format the tooltip value (e.g. GB / $). */
  valueFmt?: (n: number) => string;
  /** Tooltip series label. */
  label?: string;
}

export const Sparkline: React.FC<SparklineProps> = ({ data, color = '#6366f1', valueFmt, label = '' }) => {
  if (!data || data.length < 2) return null;
  return (
    <div className="mt-2 h-7">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 2, bottom: 2, left: 0, right: 0 }}>
          <XAxis dataKey="date" hide />
          <Tooltip
            {...chartTooltipStyle}
            formatter={((v: unknown) => [valueFmt ? valueFmt(Number(v)) : Number(v).toLocaleString(), label]) as any}
            labelFormatter={(l: unknown) => String(l)}
          />
          <Line type="monotone" dataKey="value" stroke={color} dot={false} strokeWidth={1.5} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Sparkline;
